import clsx from 'clsx';
import { Anchor, Icon, Referenz } from 'components/atoms';
import type { BeteiligungsTimelineItem } from 'types';
import { useTranslation } from 'utils/hooks';


import css from './Beteiligungen.module.scss';

interface AnteilProps
{
  item: BeteiligungsTimelineItem;
}

const Anteil: React.FC<AnteilProps> = (props) =>
{
  const { item } = props;
  const { anteil, kapital, ref, änderungsArt } = item;
  const { t } = useTranslation();

  function getFormattedKapital(): string
  {
    if (kapital.menge === 0 && kapital.währung === '0')
    {
      return t('profiles:beteiligungen.noBeteiligung');
    }

    return t('formats:money', { value: kapital });
  }

  return (
    <li className={css.anteil}>
      <Referenz data={ref}>
        {({ iconName, href }) => (
          <Anchor
            href={ref.id && ref.type !== 'AusländischesUnternehmen' ? href : undefined}
            className={clsx(css.content, {
              [css.deleted]: änderungsArt === 'Gelöscht',
              [css.foreign]: ref.type === 'AusländischesUnternehmen',
            })}
          >
            <Icon name={iconName} />
            <span className={css.name}>{ref.name}</span>
            {anteil !== null && <span className={css.percent}>{t('formats:percent', { value: anteil > 0 ? anteil / 100 : 0 })}</span>}
            {kapital && <span className={css.kapital}>{getFormattedKapital()}</span>}
          </Anchor>
        )}
      </Referenz>
    </li>
  );
};

export default Anteil;